export class dragnDropObject {

    IsFolder: boolean;
    currentUploadFolder: any;
    ffile: any;
    entry:any;

constructor (entry: any,currentUploadFolder: any,ffile:any){
   this.entry = entry
   this.currentUploadFolder = currentUploadFolder
   this.ffile = ffile;

}   

}